var api = require("!../../../../phoenix-app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../phoenix-app/node_modules/css-loader/dist/cjs.js??ref--11-1!../../../../phoenix-app/node_modules/sass-loader/dist/cjs.js??ref--11-2!../../../../phoenix-app/node_modules/postcss-loader/src/index.js!./keyframes.module.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};